export enum ProjectorName {
  PageData = 'PAGE_DATA',
  NavbarActions = 'NAVBAR_ACTIONS',
  HubContextSelection = 'HUB_CONTEXT_SELECTION',
  AllocationCalendarZoomToggle = 'ALLOCATION_CALENDAR_ZOOM_TOGGLE',
  DemurrageDetentionModeToggle = 'DEMURRAGE_DETENTION_MODE_TOGGLE',
  ShipmentChipsToolbar = 'SHIPMENT_CHIPS_TOOLBAR',
}
